// OrderItem.jsx
import React, { useState, useEffect } from 'react';
import OrderProgress from '../OrderProgress';
import OrderDetails from '../OrderDetails';
import { useAuth } from '../../contexts/AuthProvider';
import './OrderItem.css';

const OrderItem = ({ order }) => {
  const [showDetails, setShowDetails] = useState(false);
  const [localProductDetails, setLocalProductDetails] = useState(null);
  const [localProductLoading, setLocalProductLoading] = useState(false);
  const { api } = useAuth();
  
  // Get the product details for the first line item when component mounts or when order changes
  useEffect(() => {
    if (order.lineItems && order.lineItems.length > 0) {
      const firstItem = order.lineItems[0];
      // Use embedded product details if available
      if (firstItem.productDetails) {
        setLocalProductDetails(firstItem.productDetails);
      } else if (firstItem.itemId) {
        // Make a direct API call to get product details
        setLocalProductLoading(true);
        api.get(`/api/getItem/${firstItem.itemId}`)
          .then(response => {
            if (response.data.item) {
              setLocalProductDetails(response.data.item);
            }
          })
          .catch(() => {})
          .finally(() => {
            setLocalProductLoading(false);
          });
      }
    }
  }, [order.id, order.lineItems, api]);
  
  const toggleDetails = () => {
    setShowDetails(!showDetails);
  };

  
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return `${date.toLocaleDateString()} ${date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })} ${date.toTimeString().split(' ')[1].slice(0, 3)}`;
  };

  
  // Get product details - now using local state instead of context
  const getProductDetailsForDisplay = () => {    
    // First try embedded product details
    if (order.lineItems && order.lineItems.length > 0 && order.lineItems[0].productDetails) {
      return order.lineItems[0].productDetails;
    }
    // Then try local product details
    return localProductDetails;
  };
  
  // Get item name directly from first line item only
  const getItemName = () => {
    if (order.lineItems && order.lineItems.length > 0 && order.lineItems[0].name) {
      return order.lineItems[0].name;
    }
    return `Order #${order.id}`;
  };

  // Get image from product details
  const getProductImage = () => {
    const details = getProductDetailsForDisplay();
    if (details && details.image) {
      return details.image;
    }
    return '';
  };
  
  return (
    <div className="order-item-wrapper">
      <div className="order-item">
        <div className="order-content">
          <div className="order-header">
            <div className="item-name">
              {getItemName()}
            </div>
            <div className="date-ordered">
              {order.createdAt ? formatDate(order.createdAt) : 'N/A'}
            </div>
          </div>
            <div className="order-progress-container">
            <div className="order-progress-row">
              <div className="order-progress-label">
                <h3>ORDER PROGRESS:</h3>
              </div>
              <OrderProgress statusId={order.statusId} />
            </div>
          </div>
          {getProductImage() && (
            <div className="item-image-container">
              <img
                src={getProductImage()}
                alt={getItemName()}
                onError={(e) => {
                  e.target.style.display = 'none';
                }}
              />
            </div>
          )}
        
        
        </div>
      </div>
      
      <div className="order-details-section">
        <button 
          className={`view-details-button ${showDetails ? 'active' : ''}`}
          onClick={toggleDetails}
        >
          VIEW DETAILS {showDetails ? '▲' : '▼'}
        </button>
        
        {showDetails && (
          <div className="order-details-wrapper">
            <OrderDetails 
              order={order} 
              productDetails={getProductDetailsForDisplay()} 
              loading={localProductLoading} 
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default OrderItem;
